module.exports = __webpack_public_path__ + "static/media/circle-cross-line.170f615f.svg";